export default "__VITE_ASSET__CbjVPWvu__"